import React from 'react';

function ResearchProblem(props) {
    return (
        <div>
            <ul>
                <li>Cultivator's lack of knowledge about how to identify the diseases and pests and how to control them.</li>
            </ul>
            <p>
                Even though some expert cultivators are capable of identifying diseases and other potential threats to their crops, they often lack a thorough understanding of how to address these challenges. As a result, it is critical to provide them with the ability to comprehend and select the appropriate course of action when a problem emerges.
            </p>
            <ul>
                <li>Communication issues faced by the farmers when informing a spread of a disease or pests.</li>
                <li>Finding the best prices for their harvest in the current market.</li>
            </ul>
            <p>
                They cultivate based on their own personal experiences. When it comes to market, industry level farmers sell their entire product across the country, whereas rural farmers bring their goods but are unable to sell it at a decent price.
            </p>
            <ul>
                <li>Post-harvest crisis – Wastage of excess harvest and high cost for the intermediate when buying and selling the harvest. (Less profit) </li>
            </ul>
            <p>
                With regard to the last component, the requirement for an intelligent system that can anticipate the potential of a direct marketing process (buy and sell process) as well as manage the post-harvest problem through the implementation of the food banking concept was identified as a result.
            </p>

        </div>
    );
}

export default ResearchProblem;
